<template>
    <div :class="`upload-container ${cos ? 'up-cos' : ''}`">
        <div class="upload-panel-title">
            <div class="upload-info">
                <span class="info-text">{{total.queued ? $t('Uploading') : $t('Uploaded')}}</span>
                <span v-if="total.failed && !total.queued">{{$t('Failedlen',{len:total.failed})}}</span>
                <span v-if="total.queued" >（{{`${all - total.queued + 1}/${all}`}}）</span>
            </div>
            <div class="upload-panel-btn-wraper">
                <span :class="`upload-panel-btn-item ${cos ? 'rotate' : ''}`" @click="cosp">
                    <i class="components-icons components-icons-minimize"><span class="path1"></span></i>
                </span>
                <span class="upload-panel-btn-item" @click="() => $emit('close')">
                    <i class="components-icons components-icons-close"><span class="path1"></span></i>
                </span>
            </div>
        </div>
        <div class="upload-items-body">
            <upload-item :cancelFile="cancelFile" v-for="item in files" :data="item" :key="item.id" /> 
        </div>
   </div>
</template>

<script>
import Upload from '@/components/fileitem/Upload'
export default {
    props: ['files','total','cancelFile','all'],
    data(){
        return {
            cos: false
        }
    },
    components:{
        UploadItem: Upload
    },
    methods:{
        cosp(){
            this.cos = !this.cos
        }
    },
    computed:{
    }
}
</script>

<style>
.upload-container{
    display: flex;
    flex-direction: column;
    position: fixed;
    transition: bottom .3s ease;
    transition: height .2s ease;
    overflow: hidden;
    right: 135px;
    width: 450px;
    height: 430px;
    bottom: 30px;
    border: 1px solid rgba(98,107,132,.2);
    border-radius: 2px;
    box-shadow: 0 0 6px 0 rgba(98,107,132,.2);
    background-color: #fff;
}
.upload-panel-title{
    line-height: 79px;
    margin: 0 30px;
    border-bottom: 1px solid #e7e7e7;
    display: flex;
    align-items: center;
    min-width: 0;
    justify-content: space-between;
}
.upload-panel-btn-item{
    font-size: 18px;
    cursor: pointer;
    margin-left: 16px;
    color: #666;
    display: inline-block;
    transition: all 200ms;
}
.upload-panel-btn-item.rotate{
    transform: rotate(180deg);
}
.upload-info{
    font-size: 14px;
    color: #666;
}
.info-text{
    font-size: 18px;
    color: #3c414b;
    padding-right: 10px;
}
.up-cos.upload-container{
    height: 51px;
}
.up-cos .upload-panel-title{
    border: none;
    line-height: 51px;
    height: 51px;
}
.upload-items-body{
    flex: 1;
    padding: 0 30px;
    min-height: 0;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/uploader/UploadPanel.vue